// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kxJ4","comment":"styles_comment__2ZUfF"};